<div
    *ngIf="shown"
    class="toggle flex flex-row items-start justify-between"
    [class.toggle--message]="type === 'message'"
    [class.toggle--error]="type === 'error'"
    [class.toggle--notification]="type === 'notification'"
    [class.toggle--warning]="type === 'warning'"
    [class.toggle--rounded]="toggleStyle === 'rounded'"
    [class.toggle--light]="theme === 'light'"
    [class.toggle--dark]="theme === 'dark'"
    [class.toggle--left]="toggleAlign === 'left'"
    [class.toggle--center]="toggleAlign === 'center'"
    @show>

    <div class="toggle__wrapper flex flex-row flex-auto">

        <div *ngIf="icon" class="mr-3">
            <div class="toggle__icon">
                <app-icon [icon]="icon"></app-icon>
            </div>
        </div>

        <div class="toggle__content">
            <h3 *ngIf="title" class="text-semibold mb-1">{{ title }}</h3>
            <p><ng-content></ng-content></p>
        </div>

    </div>
 
    <button *ngIf="dismiss" class="toggle__icon toggle__dismiss" (click)="handleDismissClicked()">
        <app-icon icon="times">
        </app-icon>
    </button>

</div>